import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { StripeProvider } from 'react-stripe-elements';

import './buy.scss';
var windowDefined = typeof window !== `undefined`;
var stripePublicKey = `${process.env.GATSBY_STRIPE_PUBLIC_KEY}`;

class BuyPage extends Component {
    render() {
        if (!windowDefined) {
            return <div></div>;
        } else {
            if (!stripePublicKey || stripePublicKey === '' || stripePublicKey === 'undefined') {
                return <div>Stripe Public key is not specified</div>
            }

            var Checkout = require('../../../components/purchase/Checkout');
            return (
                <StripeProvider apiKey={stripePublicKey}>
                    <div className='buy-container'>
                        <Helmet title={`Datasert - Buy Realfire`} />
                        <Checkout />
                    </div>
                </StripeProvider>
            );
        }
    }
}

export default BuyPage;


// WEBPACK FOOTER //
// ./src/pages/products/realfire/buy.jsx